import script from "./MarketPlaceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketPlaceCard.vue?vue&type=script&setup=true&lang=js"

import "./MarketPlaceCard.vue?vue&type=style&index=0&id=08c34f92&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08c34f92"]])

export default __exports__